<div class="copyable-log-field" [class.copyable-log-field--button-only]="!showText()">
  <div class="copyable-log-field__head">
    @if (label()) {
      @if (isHeading3()) {
        <h3>{{ label() | translate }}</h3>
      } @else {
        <h4>{{ label() | translate }}</h4>
      }
    }
    <app-secondary-button
      [title]="buttonTitle()"
      [icon]="buttonIcon()"
      size="small"
      [disable]="!canCopy()"
      (action)="copy()"
    ></app-secondary-button>
  </div>
  @if (showText()) {
    <pre><code>{{ text() }}</code></pre>
  }
</div>
